module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQAAAADsdIMmAAAAGElEQVR4nGNgYEhjMmbSYmBgiGLiYfoCAAv7Aiav8BULAAAAAElFTkSuQmCC"